__turbopack_context__.v({
  "choose_station_button": "SX5QMq_choose_station_button",
});
